/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GroupMemberSearchViewController (this: JS5Object, $routeParams: JS5Object, $location: JS5Object,
                                          GroupsService: JS5Object, uiGridConstants: JS5Object) {
    const getData = () => {
        this.loadingIndicator.show = true;
        GroupsService.getGroup($routeParams.id, {includeUsers: true}).then((viewData: JS5Object) => {
            GroupsService.breadcrumbName = viewData.name;
            this.gridOptions.data = viewData.users;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.gridOptions = {
        rowSelection: false,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: [{
                field: 'username',
                type: 'string',
                enableSorting: true,
                sort: {
                    direction: 'asc',
                    priority: 0
                    },
                displayName: 'Username',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'firstName',
                type: 'string',
                enableSorting: true,
                displayName: 'First Name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            },
            {
                field: 'lastName',
                type: 'string',
                enableSorting: true,
                displayName: 'Last Name',
                cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
            }],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        data: []
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
           if (_.toNumber($routeParams.id) !== -1) {
               getData();
           }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        GroupsService.breadcrumbName = undefined;
        GroupsService.originalEditData = undefined;
        GroupsService.editorForm = undefined;
    };
}

angular.module('prism-ui.groups').component('groupMemberSearchView', {
    templateUrl: 'system/groups/editor/members/group-member-search-view-template.html',
    controller: GroupMemberSearchViewController,
    bindings: {
        isAdmin: '<'
    }
});
